import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { FinalizeSubscriptionComponent } from './finalize-subscription/finalize-subscription.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'finaliser/souscription/:token', component: FinalizeSubscriptionComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionRoutingModule { }
